import { render } from "./KatalogEmbrio.vue?vue&type=template&id=22f137fc"
import script from "./KatalogEmbrio.vue?vue&type=script&lang=js"
export * from "./KatalogEmbrio.vue?vue&type=script&lang=js"

import "./KatalogEmbrio.vue?vue&type=style&index=0&id=22f137fc&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__